import React from 'react';
import { Option } from '../../kingpin/atoms/ContextMenu';

const CopyGadgetButton = ({
  onClick,
  label = 'Copy Gadget',
}: {
  onClick: () => void;
  label?: string;
}) => (
  <Option
    label={label}
    icon={'copy'}
    data-testid="copy-gadget"
    onClick={onClick}
  />
);

export default CopyGadgetButton;
